export const SET_SHOW_IMPORT_MODAL = 'SET_SHOW_IMPORT_MODAL';
export const SET_HIDE_IMPORT_MODAL = 'SET_HIDE_IMPORT_MODAL';

export const ActionShowModalImport = () => {
    return {
        type: "SET_SHOW_IMPORT_MODAL",
        payload: true,
    };
};

export const ActionHideModalImport = () => {
    return {
        type: "SET_HIDE_IMPORT_MODAL",
        payload: false,
    };
    
}


